/* eslint react/no-danger: 'off' */
/* global translations */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import cx from '../../utils/cx';
import modal from '../../../legacy/app/modal';
import DailyPollStore from '../../stores/DailyPollStore';
import DailyPollActionCreators from '../../actions/DailyPollActionCreators';
import DailyPollQuestion from './DailyPollQuestion';

class DailyPollBlock extends Component {
  state = {
    poll: DailyPollStore.getDailyPoll(),
    allowSubmit: DailyPollStore.getAllowSubmit(),
    submitStatus: DailyPollStore.getSubmitStatus(),
  };

  componentDidMount() {
    DailyPollStore.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    DailyPollStore.removeChangeListener(this.onChange);
  }

  onChange = () => {
    let poll = DailyPollStore.getDailyPoll();
    let submitStatus = DailyPollStore.getSubmitStatus();

    if (submitStatus === 'error') {
      submitStatus = null;
      DailyPollStore.setSubmitStatus(submitStatus);

      const errorMsg = 'txt: Nezināma kļūda';
      modal.alert(get(translations, errorMsg, errorMsg), get(translations, 'txt: Sapratu', 'txt: Sapratu'));
    } else if (submitStatus === 'success') {
      submitStatus = null;
      poll = {};
      DailyPollStore.setSubmitStatus(submitStatus);
      DailyPollStore.setDailyPoll(poll);

      const successMsg = 'txt: Paldies, atbilde saglabāta';
      modal.alert(get(translations, successMsg, successMsg), get(translations, 'txt: Sapratu', 'txt: Sapratu'));
    }

    this.setState({
      poll,
      allowSubmit: DailyPollStore.getAllowSubmit(),
      submitStatus,
    });
  };

  setFormData = (data) => {
    DailyPollStore.setFormData(data);
    DailyPollStore.setSubmitStatus(null);
    DailyPollStore.emitChange();
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.state.allowSubmit) {
      const emptyMessage = 'txt: Nevar iesniegt tukšu atbildi';
      modal.alert(get(translations, emptyMessage, emptyMessage), get(translations, 'txt: Sapratu', 'txt: Sapratu'));
      return;
    }

    DailyPollStore.setSubmitStatus('loading');
    DailyPollStore.emitChange();

    DailyPollActionCreators.submitForm(this.props.preview);
  };

  closePoll = () => {
    DailyPollActionCreators.closePoll(this.state.poll.id, this.props.preview);

    DailyPollStore.setDailyPoll({});
    DailyPollStore.setFormData({});
    DailyPollStore.setSubmitStatus(null);
    DailyPollStore.emitChange();
  };

  render() {
    const { poll, submitStatus, allowSubmit } = this.state;
    if (!poll || !poll.type) {
      return (null);
    }

    const dailyPollStyle = {};
    if (poll.background) {
      dailyPollStyle.backgroundImage = `url(${poll.background})`;
    }

    return (
      <div
        className={cx([
          `dailyPoll dailyPoll--${poll.theme} block mbm`,
          ['loading', submitStatus === 'loading'],
        ])}
        style={dailyPollStyle}
      >
        <div className="dailyPoll-backgroundOverlay pam por">
          {submitStatus === 'loading' && (
            <div className="loading-spinner loading-spinner--vcenter" />
          )}
          <DailyPollQuestion
            poll={poll}
            setFormData={this.setFormData}
            handleSubmit={this.handleSubmit}
            submitStatus={submitStatus}
            allowSubmit={allowSubmit}
          />
          <div
            className="dailyPoll-info"
            dangerouslySetInnerHTML={{ __html: poll.description }}
          />
          <span
            className="dailyPoll-close"
            role="button"
            tabIndex="0"
            onClick={this.closePoll}
            onKeyDown={this.closePoll}
          />
        </div>
      </div>
    );
  }
}

DailyPollBlock.propTypes = {
  preview: PropTypes.bool,
};

DailyPollBlock.defaultProps = {
  preview: false,
};

export default DailyPollBlock;
